<div class="modal fade" id="memberFormModal" msEscClose
    (escPressed)="onCancelRequested()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">
                    @if (formState() === FormState.Update) {
                        Edit Profile
                    } @else {
                        Add Member to {{ organization()?.name }}
                    }
                </h5>
            </div>
            <div class="modal-body text-center">
                <ms-member-form
                    [organization]="organization()"
                    [member]="member()"
                    [formState]="formState()"
                    (submissionResult)="onMemberResult($event)"
                    (cancelRequested)="onCancelRequested()"
                    (editConfirmationRequested)="onEditConfirmationRequested()">
                </ms-member-form>
            </div>
        </div>
    </div>
</div>

<ms-info-modal #memberFormInfoModalRef modalId="memberFormInfoModal" (onConfirm)="infoModalConfirmed()" />

<ms-confirmation-modal #memberFormConfirmationModalRef
    modalId="memberFormConfirmationModal"
    confirmButtonText="Leave"
    cancelButtonText="Stay"
    (confirmed)="confirmationModalConfirmed()"
    (cancelled)="confirmationModalCancelled()"
/>

<ms-confirmation-modal #editMemberConfirmationModalRef
    modalId="editMemberConfirmationModal"
    confirmButtonText="Save"
    cancelButtonText="Cancel"
    (confirmed)="editConfirmationModalConfirmed()"
    (cancelled)="editConfirmationModalCancelled()"
/>
